import { useEffect } from "react";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { ChurchFlyer } from "@/components/site/ChurchFlyer";
import { Mission } from "@/components/site/Mission";
import { Flyer } from "@/components/site/Flyer";
import { Sermons } from "@/components/site/Sermons";
import { Events } from "@/components/site/Events";
import { Turnaround } from "@/components/site/Turnaround";
import { Fundraising } from "@/components/site/Fundraising";
import { GetInvolved } from "@/components/site/GetInvolved";
import { Membership } from "@/components/site/Membership";
import { VendorRegistration } from "@/components/site/VendorRegistration";
import { Footer } from "@/components/site/Footer";
import { usePageTracking } from "@/hooks/usePageTracking";
import { trackSection } from "@/lib/analytics";

const SECTION_NAMES = {
  top: "Home",
  vision: "Vision",
  flyer: "Launch",
  sermons: "Sermons",
  events: "Events",
  turnaround: "Turnaround Project",
  vendor: "Vendor Registration",
  support: "Fundraising",
  involved: "Get Involved",
  membership: "Membership",
};

export default function Landing() {
  usePageTracking("/");

  useEffect(() => {
    const seen = new Set();
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !seen.has(entry.target.id)) {
            seen.add(entry.target.id);
            trackSection(SECTION_NAMES[entry.target.id] || entry.target.id);
          }
        });
      },
      { threshold: 0.4 }
    );
    Object.keys(SECTION_NAMES).forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-[#06040A] min-h-screen" data-testid="landing-page">
      <Header />
      <Hero />
      <ChurchFlyer />
      <Mission />
      <Flyer />
      <Sermons />
      <Events />
      <Turnaround />
      <VendorRegistration />
      <Fundraising />
      <GetInvolved />
      <Membership />
      <Footer />
    </div>
  );
}
